<template>
    <div>
        <b-card class="text-center">
            <h2 class="mb-5"><b>ETIQUETAS</b></h2>
            <b-row class="align-items-center justify-content-center">
                <b-col cols='12' class="text-center">
                    <b-select class="text-center escolha_col_etiqueta" :options='etiquetas' v-model="escolha"></b-select>
                </b-col>
                <b-col cols='12' class="my-2">
                    <etiquetas :escolha="escolha"/>
                </b-col>
                <b-col class="mt-2" cols='12'>
                    <b-textarea rows='9' class="mb-2" v-model="produtos"></b-textarea>
                    <b-button @click="Baixar()">Gerar</b-button>
                </b-col>
            </b-row>
        </b-card>
        <!-- <router-link :to="{name: 'First', query:{etiqueta: 2}}" target='_blank'>
            Teste
        </router-link> -->
    </div>
</template>

<script>
export default{
    data(){
        return{
            escolha: 1,
            etiquetas: [
                {value: 1, text: 'Etiqueta 1'},
                {value: 2, text: 'Etiqueta 2'},
                {value: 3, text: 'Etiqueta 3'},
                {value: 4, text: 'Etiqueta 4'}
            ],
            produtos: null,
            array_produtos: []
        }
    },

    computed:{
       
    },

    methods:{
        Baixar(){
            const idAleatorio = Math.floor(Math.random() * 10000000);

            var fix = 3
            if(this.escolha == 3 || this.escolha == 4){
                fix = 5
            }
            var produtos_pre = ""
            var produtos_pos = []
            var dados = []
            var aux = 1
            if(this.produtos){
                dados = this.produtos.split("\n")
                dados.forEach((element, index) => {
                    if(aux == fix){
                        produtos_pre += element
                        produtos_pos.push(produtos_pre)
                        produtos_pre = ""
                        aux = 1
                        
                    }else{
                        produtos_pre += element + ";"
                        if(index != (dados.length - 1)){
                            aux += 1
                        }
                    }
                });
            }

            if(aux < fix){
                produtos_pos.push(produtos_pre.substring(0, produtos_pre.length - 1))
            }

            let data = {
                produtos: produtos_pos,
                etiqueta: this.escolha,
                id: idAleatorio
            }

            console.log(data)

            axios
                .post("/distribuidor/get-link-etiqueta", data)
                .then(function (response) {
                    window.open(`/distribuidor/imprimir-etiqueta/${response.data.resource}`, '_blank');
                })
                .catch(function (error) {
                    alert(error.response.data.join("\n"))
                });
        },
    }
}
</script>

<style>
    .l-section{
        width: auto !important;
    }
    .escolha_col_etiqueta{
        max-width: 300px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/EtiquetaIndex.vue